async function getCollectionInfo(id: string) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/collections/${id}`;

  const res = await fetch(url);
  const collectionInfo = await res.json();

  return collectionInfo;
}

export default getCollectionInfo;
